var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUzbekistan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_4179)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26_4179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26_4179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 3H3V9.40107H37.2819V3Z",
    fill: "#4497B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 9.39438H3V9.79612H37.2819V9.39438Z",
    fill: "#BC0030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 9.79612H3V16.1972H37.2819V9.79612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 16.1972H3V16.5989H37.2819V16.1972Z",
    fill: "#BC0030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 16.5989H3V23H37.2819V16.5989Z",
    fill: "#50B63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0013 6.19384C11.0013 7.51958 9.92332 8.59089 8.60427 8.59089C7.27852 8.59089 6.20721 7.51289 6.20721 6.19384C6.20721 4.86809 7.28522 3.79678 8.60427 3.79678C9.92332 3.79678 11.0013 4.87479 11.0013 6.19384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6776 6.19384C11.6776 7.29863 10.7804 8.19585 9.67559 8.19585C8.5708 8.19585 7.67358 7.29863 7.67358 6.19384C7.67358 5.08905 8.5708 4.19183 9.67559 4.19183C10.7804 4.19853 11.6776 5.09575 11.6776 6.19384Z",
    fill: "#4497B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6773 3.79678L14.53 4.25209L14.7576 4.32574L14.6773 3.79678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6773 3.79678L14.8246 4.25209L14.5969 4.32574L14.6773 3.79678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1326 4.13157H14.6572V4.36592L15.1326 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1326 4.13157L14.7442 4.41279L14.6036 4.21861L15.1326 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 4.13157L14.6103 4.41279L14.7509 4.21861L14.222 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 4.13157H14.7041V4.36592L14.222 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9585 4.66723L14.8112 4.20522L14.5836 4.28557L14.9585 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9585 4.66723L14.5701 4.38601L14.7107 4.19183L14.9585 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3961 4.66723L14.7844 4.38601L14.6438 4.19183L14.3961 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3961 4.66723L14.5434 4.20522L14.771 4.28557L14.3961 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 3.79678L16.4516 4.25209L16.6793 4.32574L16.5989 3.79678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 3.79678L16.7462 4.25209L16.5186 4.32574L16.5989 3.79678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 4.13157H16.5721V4.36592L17.0542 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 4.13157L16.6659 4.41279L16.5253 4.21861L17.0542 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1436 4.13157L16.532 4.41279L16.6726 4.21861L16.1436 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1436 4.13157H16.619V4.36592L16.1436 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8801 4.66723L16.7328 4.20522L16.5052 4.28557L16.8801 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8802 4.66723L16.4918 4.38601L16.6324 4.19183L16.8802 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3177 4.66723L16.706 4.38601L16.5654 4.19183L16.3177 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3177 4.66723L16.465 4.20522L16.6926 4.28557L16.3177 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5206 3.79678L18.3733 4.25209L18.6009 4.32574L18.5206 3.79678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5206 3.79678L18.6679 4.25209L18.4402 4.32574L18.5206 3.79678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9759 4.13157H18.4938V4.36592L18.9759 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9759 4.13157L18.5876 4.41279L18.447 4.21861L18.9759 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 4.13157L18.4469 4.41279L18.5942 4.21861L18.0586 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 4.13157H18.5407V4.36592L18.0586 4.13157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 4.66723L18.6545 4.20522L18.4269 4.28557L18.8018 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 4.66723L18.4135 4.38601L18.5541 4.19183L18.8018 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2394 4.66723L18.6277 4.38601L18.4804 4.19183L18.2394 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2394 4.66723L18.3867 4.20522L18.6143 4.28557L18.2394 4.66723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7556 5.71844L12.6083 6.17375L12.8359 6.2474L12.7556 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7556 5.71844L12.9096 6.17375L12.6819 6.2474L12.7556 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2176 6.04653H12.7355V6.28758L13.2176 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2176 6.04653L12.8293 6.32775L12.6887 6.13358L13.2176 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3003 6.04653L12.6886 6.32775L12.8293 6.13358L12.3003 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3003 6.04653H12.7824V6.28758L12.3003 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 6.58219L12.8895 6.12688L12.6619 6.20054L13.0435 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 6.58219L12.6552 6.30097L12.7958 6.1068L13.0435 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4744 6.58219L12.8627 6.30097L12.7221 6.1068L12.4744 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4744 6.58219L12.6284 6.12688L12.856 6.20054L12.4744 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6773 5.71844L14.53 6.17375L14.7576 6.2474L14.6773 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6773 5.71844L14.8246 6.17375L14.5969 6.2474L14.6773 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1326 6.04653H14.6572V6.28758L15.1326 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1326 6.04653L14.7442 6.32775L14.6036 6.13358L15.1326 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 6.04653L14.6103 6.32775L14.7509 6.13358L14.222 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 6.04653H14.7041V6.28758L14.222 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9585 6.58219L14.8112 6.12688L14.5836 6.20054L14.9585 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9585 6.58219L14.5701 6.30097L14.7107 6.1068L14.9585 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3961 6.58219L14.7844 6.30097L14.6438 6.1068L14.3961 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3961 6.58219L14.5434 6.12688L14.771 6.20054L14.3961 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 5.71844L16.4516 6.17375L16.6793 6.2474L16.5989 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 5.71844L16.7462 6.17375L16.5186 6.2474L16.5989 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 6.04653H16.5721V6.28758L17.0542 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 6.04653L16.6659 6.32775L16.5253 6.13358L17.0542 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1436 6.04653L16.532 6.32775L16.6726 6.13358L16.1436 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1436 6.04653H16.619V6.28758L16.1436 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8801 6.58219L16.7328 6.12688L16.5052 6.20054L16.8801 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8802 6.58219L16.4918 6.30097L16.6324 6.1068L16.8802 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3177 6.58219L16.706 6.30097L16.5654 6.1068L16.3177 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3177 6.58219L16.465 6.12688L16.6926 6.20054L16.3177 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5206 5.71844L18.3733 6.17375L18.6009 6.2474L18.5206 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5206 5.71844L18.6679 6.17375L18.4402 6.2474L18.5206 5.71844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9759 6.04653H18.4938V6.28758L18.9759 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9759 6.04653L18.5876 6.32775L18.447 6.13358L18.9759 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 6.04653L18.4469 6.32775L18.5942 6.13358L18.0586 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 6.04653H18.5407V6.28758L18.0586 6.04653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 6.58219L18.6545 6.12688L18.4269 6.20054L18.8018 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 6.58219L18.4135 6.30097L18.5541 6.1068L18.8018 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2394 6.58219L18.6277 6.30097L18.4804 6.1068L18.2394 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2394 6.58219L18.3867 6.12688L18.6143 6.20054L18.2394 6.58219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8407 7.64011L10.6934 8.09541L10.921 8.16906L10.8407 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8407 7.64011L10.988 8.09541L10.7603 8.16906L10.8407 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2959 7.96819H10.8138V8.20924L11.2959 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2959 7.96819L10.9076 8.24941L10.767 8.05524L11.2959 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3853 7.96819L10.7737 8.24941L10.9143 8.05524L10.3853 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3853 7.96819H10.8607V8.20924L10.3853 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1218 8.50385L10.9745 8.04855L10.7469 8.1222L11.1218 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1219 8.50385L10.7335 8.22263L10.8741 8.02846L11.1219 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5594 8.50385L10.9478 8.22263L10.8072 8.02846L10.5594 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5594 8.50385L10.7068 8.04855L10.9344 8.1222L10.5594 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7556 7.64011L12.6083 8.09541L12.8359 8.16906L12.7556 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7556 7.64011L12.9096 8.09541L12.6819 8.16906L12.7556 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2176 7.96819H12.7355V8.20924L13.2176 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2176 7.96819L12.8293 8.24941L12.6887 8.05524L13.2176 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3003 7.96819L12.6886 8.24941L12.8293 8.05524L12.3003 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3003 7.96819H12.7824V8.20924L12.3003 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 8.50385L12.8895 8.04855L12.6619 8.1222L13.0435 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 8.50385L12.6552 8.22263L12.7958 8.02846L13.0435 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4744 8.50385L12.8627 8.22263L12.7221 8.02846L12.4744 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4744 8.50385L12.6284 8.04855L12.856 8.1222L12.4744 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6773 7.64011L14.53 8.09541L14.7576 8.16906L14.6773 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6773 7.64011L14.8246 8.09541L14.5969 8.16906L14.6773 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1326 7.96819H14.6572V8.20924L15.1326 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1326 7.96819L14.7442 8.24941L14.6036 8.05524L15.1326 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 7.96819L14.6103 8.24941L14.7509 8.05524L14.222 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.222 7.96819H14.7041V8.20924L14.222 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9585 8.50385L14.8112 8.04855L14.5836 8.1222L14.9585 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9585 8.50385L14.5701 8.22263L14.7107 8.02846L14.9585 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3961 8.50385L14.7844 8.22263L14.6438 8.02846L14.3961 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3961 8.50385L14.5434 8.04855L14.771 8.1222L14.3961 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 7.64011L16.4516 8.09541L16.6793 8.16906L16.5989 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 7.64011L16.7462 8.09541L16.5186 8.16906L16.5989 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 7.96819H16.5721V8.20924L17.0542 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0542 7.96819L16.6659 8.24941L16.5253 8.05524L17.0542 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1436 7.96819L16.532 8.24941L16.6726 8.05524L16.1436 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1436 7.96819H16.619V8.20924L16.1436 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8801 8.50385L16.7328 8.04855L16.5052 8.1222L16.8801 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8802 8.50385L16.4918 8.22263L16.6324 8.02846L16.8802 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3177 8.50385L16.706 8.22263L16.5654 8.02846L16.3177 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3177 8.50385L16.465 8.04855L16.6926 8.1222L16.3177 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5206 7.64011L18.3733 8.09541L18.6009 8.16906L18.5206 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5206 7.64011L18.6679 8.09541L18.4402 8.16906L18.5206 7.64011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9759 7.96819H18.4938V8.20924L18.9759 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9759 7.96819L18.5876 8.24941L18.447 8.05524L18.9759 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 7.96819L18.4469 8.24941L18.5942 8.05524L18.0586 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0586 7.96819H18.5407V8.20924L18.0586 7.96819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 8.50385L18.6545 8.04855L18.4269 8.1222L18.8018 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8018 8.50385L18.4135 8.22263L18.5541 8.02846L18.8018 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2394 8.50385L18.6277 8.22263L18.4804 8.02846L18.2394 8.50385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2394 8.50385L18.3867 8.04855L18.6143 8.1222L18.2394 8.50385Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_4179",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_4179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_4179",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzbekistan);
export default __webpack_public_path__ + "static/media/Uzbekistan.c931cc4e86fb47deae53eb7ab799dae8.svg";
export { ForwardRef as ReactComponent };